var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-ueditor-wrap',{attrs:{"config":_vm.editorConfig,"editorDependencies":['ueditor.config.js','ueditor.all.js'],"editor-id":"editor"},on:{"ready":_vm.ready},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }